import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const testimonials = [
  {
    quote: "The live magnets were the absolute highlight of our wedding! Guests couldn't stop talking about them, and the quality is stunning.",
    author: "Sarah & James",
    event: "Wedding Celebration"
  },
  {
    quote: "Magnet Parlor elevated our corporate gala. The elegant branding on the magnets provided a sophisticated touch that our clients loved.",
    author: "Michael T.",
    event: "Corporate Gala"
  },
  {
    quote: "Such a beautiful addition to my daughter's Quinceañera. The photos are crystal clear and perfectly captured the magic of the night.",
    author: "Elena R.",
    event: "Quinceañera"
  },
  {
    quote: "The kids were so excited to see themselves on magnets. Best party favor ever! Every parent asked for your contact info.",
    author: "Jessica L.",
    event: "Birthday Party"
  },
  {
    quote: "A meaningful keepsake for a meaningful day. Exceptional service and the artisan 'parlor' vibe matched our event perfectly.",
    author: "David B.",
    event: "Bar Mitzvah"
  },
  {
    quote: "Added that extra spark to our year-end holiday event. It brought people together and gave them something to cherish.",
    author: "Amanda W.",
    event: "Holiday Gala"
  },
  {
    quote: "Elegant, fun, and so unique. Every guest went home happy with a little piece of the bridal shower to keep on their fridge.",
    author: "Chloe M.",
    event: "Bridal Shower"
  },
  {
    quote: "Helped us raise awareness while giving donors a memory to take home. The custom branding was subtle and high-end.",
    author: "Mark S.",
    event: "Charity Fundraiser"
  }
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const next = () => setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  const prev = () => setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);

  return (
    <section className="py-24 bg-parlor-cream overflow-hidden border-t border-parlor-gold/10">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <SafeIcon icon={FiIcons.FiStar} className="text-parlor-gold text-4xl mx-auto mb-8" />
        
        <div className="relative h-72 md:h-56 flex items-center justify-center">
          <AnimatePresence mode="wait">
            <motion.div
              key={currentIndex}
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.5 }}
              className="absolute w-full"
            >
              <p className="font-serif text-xl md:text-2xl lg:text-3xl text-parlor-green leading-relaxed mb-8 px-4 italic">
                "{testimonials[currentIndex].quote}"
              </p>
              <div className="uppercase tracking-widest text-xs md:text-sm font-semibold text-parlor-green">
                {testimonials[currentIndex].author}
                <span className="text-parlor-gold mx-2">|</span>
                <span className="text-parlor-green/60 font-normal">{testimonials[currentIndex].event}</span>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="flex justify-center items-center gap-6 mt-12">
          <button onClick={prev} className="p-2 text-parlor-green/30 hover:text-parlor-gold transition-colors">
            <SafeIcon icon={FiIcons.FiArrowLeft} className="text-2xl" />
          </button>
          
          <div className="flex gap-2">
            {testimonials.map((_, idx) => (
              <button 
                key={idx}
                onClick={() => setCurrentIndex(idx)}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${idx === currentIndex ? 'bg-parlor-gold w-6' : 'bg-parlor-green/20'}`}
              />
            ))}
          </div>

          <button onClick={next} className="p-2 text-parlor-green/30 hover:text-parlor-gold transition-colors">
            <SafeIcon icon={FiIcons.FiArrowRight} className="text-2xl" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;